import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../store';
import { logout } from '../../store/authSlice';
import { useInactivityTimer } from '../../hooks/useInactivityTimer';
import InactivityWarningDialog from './InactivityWarningDialog';

interface Props {
  children: React.ReactNode;
}

const InactivityManager: React.FC<Props> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await dispatch(logout()).unwrap();
    } catch (_) {
      // fail-secure: auth slice already clears state on rejection
    }
    navigate('/login', { replace: true });
  }, [dispatch, navigate]);

  const { showWarning, secondsLeft, stayLoggedIn, logoutNow } = useInactivityTimer(handleLogout);

  return (
    <>
      {children}
      <InactivityWarningDialog
        open={showWarning}
        secondsLeft={secondsLeft}
        onStayLoggedIn={stayLoggedIn}
        onLogoutNow={logoutNow}
      />
    </>
  );
};

export default InactivityManager;
